const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class NewDeposits extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.NewDeposits,
            "Each civilization produces resources immediately. Ignore corruption.",
            {}
        )
    }
}

module.exports = NewDeposits;